import { render, staticRenderFns } from "./comFinInfo.vue?vue&type=template&id=73586456&scoped=true&"
import script from "./comFinInfo.vue?vue&type=script&lang=js&"
export * from "./comFinInfo.vue?vue&type=script&lang=js&"
import style0 from "./comFinInfo.vue?vue&type=style&index=0&id=73586456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73586456",
  null
  
)

export default component.exports